export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export const REQUEST_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
  TRACE: 'TRACE',
  CONNECT: 'CONNECT'
};

export const endpoints = {
  accounts: {
    login: '/Accounts/login',
    logout: '/Accounts/logout',
    profile: '/Accounts/profile',
    refresh: '/Accounts/refresh'
  },
  courses: {
    list: '/StaffCourses',
    idpCourses: '/StaffCourses/GetIDPCourses',
    course: '/StaffCourses/course',
    userCourses: '/StaffCourses/userCourses',
    myCourseList: '/StaffCourses/myCourseList',
    courseProgress: '/StaffCourses/courseProgress',
    request: '/StaffCourses/request',
    subscribe: '/StaffCourses/subscribe',
    getRequests: '/StaffCourses/requests',
    pendingCourses: '/StaffCourses/pendingCourses',
    overdueCourses: '/StaffCourses/overdueCourses',
    requestStatus: (requestRef) => `/StaffCourses/request/${requestRef}/status`,
    approveRequest: (requestRef) => `/StaffCourses/request/${requestRef}/approve`,
    denyRequest: (requestRef) => `/StaffCourses/request/${requestRef}/deny`
  },
  admin: {
    login: '/Admin/login',
    refresh: '/Admin/refresh',
    logout: '/Admin/logout',
    profile: '/Admin/profile',
    dashboardStats: '/Admin/dashboard/stats',
    requestsByDepartment: '/Admin/requests/byDepartment',
    requestDetail: '/Admin/requests/detail',
    requests: '/Admin/requests'
  },
  tasks: {
    list: '/StaffCourses/userCourses'
  },
  staffCourses: {
    idpCourses: '/StaffCourses/GetIDPCourses'
  }
};
